import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import Sidebar from '../../../components/Sidebar/Sidebar'
import { Tab, tabClasses, TabList, TabPanel, Tabs } from '@mui/joy';
import { haspermission } from '../../../Script/Permission';
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import EditPanel from './EditPanel';
import ElementBeschlussbuch from './ElementBeschlussbuch';
import Headline from '../../../components/headline/Headline';

function Beschlussbuch() {
    const [wit, setwith] = useState("90.5%");
    const [index, setIndex] = React.useState(0);
    const [hasperm, sethasperm] = React.useState(haspermission("22"));
    const [hasedit, sethasedit] = React.useState(haspermission("24"));
    const [hasdelete, sethasdelee] = React.useState(haspermission("24"));
    const [hashistory, sethashistory] = React.useState(haspermission("15"));
    const [data, setdata] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/beschlussbuch");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setdata(JSON.parse(response));
    }, []);
    function update() {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body, "/beschlussbuch");
        if (response == "LOGOUT") {
            navigate("/");
        }
        setdata(JSON.parse(response));
    }
    return (
        <>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center", overflowY: "auto" }}>
                <Headline title={"Beschlussbuch"}/>
                <Tabs
                    aria-label="Pipeline"
                    value={index}
                    onChange={(event, value) => {
                        if (value == 2){
                            navigate("/page-history/beschlussbuch");
                        }
                        setIndex(value)
                    }}
                    sx={{ mt: 0, width: "100%", height: "100vh" }}
                >
                    <TabList
                        sx={{
                            pt: 1,
                            justifyContent: 'center',
                            [`&& .${tabClasses.root}`]: {
                                flex: 'initial',
                                bgcolor: 'transparent',
                                '&:hover': {
                                    bgcolor: 'transparent',
                                },
                                [`&.${tabClasses.selected}`]: {
                                    color: 'primary.plainColor',
                                    '&::after': {
                                        height: 2,
                                        borderTopLeftRadius: 3,
                                        borderTopRightRadius: 3,
                                        bgcolor: 'primary.500',
                                    },
                                },
                            },
                        }}
                    >
                        <Tab
                            variant="soft"
                            color="neutral">Besschlussbuch</Tab>
                        {
                            hasperm && (
                                <Tab
                                    variant="soft"
                                    color="neutral">Bearbeiten</Tab>
                            )
                        }
                        {
                            hashistory && (
                                <Tab
                                    variant="soft"
                                    color="neutral">Historie</Tab>   
                            )
                        }

                    </TabList>
                    <TabPanel value={1}><EditPanel data={data} update={update} del={hasdelete} edit={hasedit} /></TabPanel>
                    <TabPanel sx={{ overflowY: "auto" }} value={0}>
                        {
                            data && data.result.slice().sort((a, b) => b.stamp - a.stamp).map((item) => {
                                return (
                                    <ElementBeschlussbuch item={item} edit={false} del={false} />
                                )


                            })
                        }
                    </TabPanel>
                </Tabs>




            </div>



            <div><NavigationBar state={"verein"} back={true} /></div>
            <Sidebar />
        </>
    )
}

export default Beschlussbuch
